export const environment = {
    production: false,
    hmr: false,
    staging: false,
    dev: true,
    appConfig: 'appconfig.dev.json'
};
